<div
  class="w-full flex justify-center items-center bg-cover bg-center bg-no-repeat bg-[url('/assets/images/Group_73.webp')] h-[230px] sm:h-[180px] relative px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div class="absolute inset-0 bg-black opacity-80"></div>
  <div
    class="grid xl:grid-cols-4 items-center gap-y-3 container mx-auto relative z-10"
  >
    <div>
      <button
        type="button"
        (click)="goBack()"
        class="flex items-center text-white cursor-pointer"
      >
        <span class="mr-2">&larr;</span>
        <span>Back</span>
      </button>
    </div>

    <div
      class="xl:col-span-2 sm:w-fit w-full flex flex-col sm:items-center p-3 sm:p-0 space-y-2 sm:space-y-0 sm:flex-row bg-white shadow-md rounded-xl sm:rounded-full sm:h-[45px] overflow-hidden"
    >
      <div class="flex items-center sm:ps-4 sm:py-2">
        <span
          class="w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold border !border-blue-600 text-blue-600"
        >
          1
        </span>
        <span class="ml-2 font-medium text-blue-500 text-sm"
          >Listing Details</span
        >
      </div>

      <span
        class="mx-3 text-gray-400 size-[34px] -ml-2 border-t border-r !border-black/50 rotate-45 hidden sm:block"
      ></span>

      <div class="flex items-center text-gray-400 sm:pe-4 sm:ps-2 sm:py-2">
        <span
          class="w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold border"
        >
          2
        </span>
        <span class="ml-2 font-medium">Add Photos</span>
      </div>

      <span
        class="mx-3 text-gray-400 size-[34px] -ml-2 border-t border-r !border-black/50 rotate-45 hidden sm:block"
      ></span>

      <div class="flex sm:items-center text-gray-400 sm:pe-4 sm:ps-2 sm:py-2">
        <span
          class="w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold border"
        >
          3
        </span>
        <span class="ml-2 font-medium">Checkout</span>
      </div>
    </div>

    <div class="justify-center items-center gap-5 hidden xl:flex">
      <out-button
        label="Save Draft"
        [disabled]="isSavingToContinue || isDraftSaving"
        [isLoading]="isDraftSaving"
        loadingLabel="Saving"
        (click)="draftSave()"
        buttonClass="!px-8 py-2 rounded-full border-2 !border-white text-white w-fit cursor-pointer duration-200 transition-all active:scale-95"
      >
      </out-button>

      <out-button
        [disabled]="isSavingToContinue || isDraftSaving"
        label="Continue"
        loadingLabel="Saving"
        (clicked)="saveListingAndContinue()"
        [isLoading]="isSavingToContinue"
        buttonClass="!px-8 py-2 rounded-full border-2 !border-[#1466C9] bg-[#1466C9] text-white w-fit cursor-pointer duration-200 transition-all active:scale-95"
      >
      </out-button>
    </div>
  </div>
</div>

<div class="page-content relative m-0 pb-[40px] md:pb-[70px] pt-[30px]">
  <div class="m-0 block">
    <form [formGroup]="form" class="verhicle-form m-0">
      <section
        class="px-3 md:px-5 2xl:px-28 3xl:px-52 listing_general-info m-0"
        formGroupName="vehicle"
      >
        <div class="container mx-auto relative w-full text-left">
          <div class="flex flex-wrap text-left items-center w-full">
            <div
              *ngIf="errorMessages.length > 0"
              class="inline-notice m-[2.5rem_0_3rem] p-[2rem_2rem_1rem] bg-[#f9e7ea] rounded-[.5rem] w-full"
            >
              <p class="text-[#222] m-[0_0_1rem] leading-[1.45] font-semibold">
                Please correct the following errors:
              </p>
              <ul class="p-0 m-[0_0_1rem_2rem]">
                <li
                  *ngFor="let errorMessage of errorMessages"
                  class="#222 m-[0_0_.5rem] leading-[1.45] font-[400] list-disc"
                >
                  {{ errorMessage }}
                </li>
              </ul>
            </div>
          </div>
          <div class="w-full">
            <div class="border rounded-lg px-6 py-10 shadow-md">
              <div class="w-full mb-10 text-left">
                <h3 class="text-left font-[500] text-[#000]">
                  Tell us about your Tesla
                </h3>
                <p class="font-[400] text-[#6c7884]">
                  All fields are required unless marked as optional
                </p>
              </div>
              <section class="w-full">
                <out-input
                  [id]="'vin'"
                  [name]="'VIN'"
                  [label]="'VIN #'"
                  [placeholder]="'VIN number'"
                  [required]="true"
                  [control]="getControl('vehicle.vin')"
                  [type]="'text'"
                  [errorMessage]="'Must provide a valid VIN.'"
                  (valueChange)="onVinInputChange('vehicle.vin', $event)"
                  [acl]="''"
                ></out-input>
              </section>
              <section class="grid lg:grid-cols-2 gap-y-2 gap-x-4">
                <out-input
                  [id]="'year'"
                  [name]="'Year'"
                  [label]="'Year'"
                  [required]="true"
                  [control]="getControl('vehicle.year')"
                  [type]="'text'"
                  [errorMessage]="'Must provide a valid year.'"
                  (valueChange)="onControlChange('vehicle.year', $event)"
                  [acl]="''"
                ></out-input>

                <out-select
                  [id]="'model'"
                  [name]="'Model'"
                  [label]="'Model'"
                  [required]="true"
                  [multiSelect]="false"
                  [errorMessage]="'Must select a valid option.'"
                  [placeholder]="'Choose model'"
                  [control]="getControl('vehicle.model')"
                  [items]="options.modelsOptions"
                >
                </out-select>
                <out-input
                  [id]="'color'"
                  [name]="'Color'"
                  [label]="'Color'"
                  [required]="true"
                  [control]="getControl('vehicle.specification.colour')"
                  [type]="'text'"
                  [errorMessage]="'Must provide a color.'"
                  (valueChange)="onControlChange('vehicle.specification.colour', $event)"
                ></out-input>

                <!-- <out-select
                  [id]="'trim'"
                  [name]="'Trim'"
                  [label]="'Trim'"
                  [required]="true"
                  [errorMessage]="'Must select a valid option.'"
                  [control]="getControl('vehicle.trim')"
                  [items]="options.trim"
                >
                </out-select> -->

                <out-select
                  [id]="'condition'"
                  [name]="'Condition'"
                  [label]="'Condition'"
                  [required]="true"
                  [errorMessage]="'Must select a valid option.'"
                  [control]="getControl('vehicle.condition')"
                  [items]="options.condition"
                >
                </out-select>

                <out-input
                  [id]="'mileage'"
                  [name]="'Mileage'"
                  [label]="'Mileage'"
                  [required]="true"
                  [control]="getControl('vehicle.mileage')"
                  [type]="'text'"
                  [errorMessage]="'Required. Format must be ###,###.'"
                  [value]="formatNumber(getControl('vehicle.mileage').value)"
                  (valueChange)="onControlChange('vehicle.mileage', $event)"
                ></out-input>

                <out-input
                  [id]="'askingPrice'"
                  [name]="'askingPrice'"
                  [label]="'Asking price'"
                  [required]="true"
                  [control]="getControl('price.value')"
                  [type]="'text'"
                  [errorMessage]="
                            'Required. Format must be ###,###.'
                          "
                  [value]="formatNumber(getControl('price.value').value)"
                  (valueChange)="onControlChange('price.value', $event)"
                ></out-input>

                <out-select
                  [id]="'listingType'"
                  [name]="'listingType'"
                  [label]="'Listing type'"
                  [required]="true"
                  [errorMessage]="'Must select a valid option.'"
                  [control]="getControl('type')"
                  [items]="options.listingType"
                >
                </out-select>

                <out-select
                  [id]="'country'"
                  [name]="'country'"
                  [label]="'Country'"
                  [errorMessage]="'Must select a valid option.'"
                  [control]="getControl('location.country')"
                  [items]="options.country"
                >
                </out-select>

                <out-input
                  [id]="'city'"
                  [name]="'city'"
                  [label]="'City'"
                  [required]="true"
                  [control]="getControl('location.city')"
                  [type]="'text'"
                  [errorMessage]="'Must provide a valid city.'"
                  (valueChange)="onControlChange('location.city', $event)"
                ></out-input>

                <out-select
                  [id]="'state'"
                  [name]="'state'"
                  [label]="'State'"
                  [required]="true"
                  [errorMessage]="' Must select a valid option.'"
                  [control]="getControl('location.state')"
                  [items]="options.state"
                >
                </out-select>

                <div
                  *ngIf="
              form.get('type')?.value === 'LeaseTakeover'
            "
                  class="lease-remaining"
                >
                  <out-input
                    [id]="'leaseRemaining'"
                    [name]="'leaseRemaining'"
                    [label]="'Lease remaining'"
                    [control]="getControl('vehicle.lease.monthsRemaining')"
                    [type]="'number'"
                    [errorMessage]="'Must provide a valid city.'"
                    (valueChange)="onControlChange('vehicle.lease.monthsRemaining', $event)"
                  ></out-input>
                </div>
              </section>
              <section class="">
                <div
                  class="xl:mb-[1rem] ml-[-1.6rem] flex flex-wrap items-center text-left"
                >
                  <div
                    class="w-full flex-shrink flex-grow basis-[100%] pl-[1.6rem] text-left"
                  >
                    <div class="summary">
                      <span class="h-[150px] w-full">
                        <out-input
                          [id]="'summary'"
                          [name]="'summary'"
                          [label]="'Summary'"
                          [required]="true"
                          [control]="getControl('content.description')"
                          [type]="'text'"
                          [errorMessage]="
                                'A minimum of 100 characters is required.'
                              "
                          (valueChange)="onControlChange('content.description', $event)"
                          [type]="'textarea'"
                        ></out-input>
                      </span>
                    </div>
                  </div>
                </div>
              </section>
              <div class="container pb-[1.6rem] relative">
                <div class="flex flex-wrap items-center">
                  <div class="pt-[1.6rem] flex-grow flex-shrink basis-[100%]">
                    <span class="font-[500]"
                      >Does the vehicle have Autopilot? ({{autopilot ? "Yes" :
                      "No"}})</span
                    >
                    <div class="flex flex-wrap m-0 text-left items-center">
                      <div
                        class="flex-grow flex-shrink basis-[100%] pt-2 text-left"
                      >
                        <input
                          value="Yes"
                          type="radio"
                          id="autopilotYes"
                          [checked]="autopilot === true"
                          (click)="autopilot = true"
                          class="mr-[3.5px]"
                        />
                        <label for="autopilotYes">Yes</label>
                        <input
                          value="No"
                          type="radio"
                          id="autopilotNo"
                          [checked]="autopilot === false"
                          (click)="autopilot = false "
                          class="mr-[3px] ml-[1.4rem]"
                        />
                        <label for="autopilotNo">No</label>
                      </div>
                    </div>
                    <div class="flex flex-wrap items-center text-left">
                      <div
                        *ngIf="autopilot"
                        class="w-full flex-shrink flex-grow basis-[100%] md:basis-[50%] pt-[1.6rem] text-left"
                      >
                        <div class="autopilot">
                          <out-select
                            [id]="'autopilot'"
                            [name]="'state'"
                            [label]="'Autopilot version'"
                            [errorMessage]="' Must select a valid option.'"
                            [control]="getControl('vehicle.features.autopilot')"
                            [items]="options.autopilotOptions"
                          >
                          </out-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container pb-[1.6rem] relative">
                <div class="flex flex-wrap items-center">
                  <div
                    class="w-full flex-shrink flex-grow basis-[100%] md:basis-[50%] text-left"
                  >
                    <span class="font-[500]"
                      >Clean history? ({{ cleanHistory ? 'Yes' : 'No' }})</span
                    >
                    <div class="flex flex-wrap m-0 text-left items-center">
                      <div
                        class="flex-grow flex-shrink basis-[100%] pt-2 text-left pb-[1.6rem] md:pb-0"
                      >
                        <input
                          type="radio"
                          id="cleanHistoryYes"
                          [checked]="cleanHistory === true"
                          (click)="cleanHistory = true"
                          class="mr-[3.5px]"
                        />
                        <label for="cleanHistoryYes">Yes</label>
                        <input
                          value="No"
                          type="radio"
                          id="cleanHistoryNo"
                          [checked]="cleanHistory === false"
                          (click)="cleanHistory = false"
                          class="mr-[3px] ml-[1.4rem]"
                        />
                        <label for="cleanHistoryNo">No</label>
                      </div>
                    </div>
                  </div>
                  <div
                    class="w-full flex-shrink flex-grow basis-[100%] md:basis-[50%] text-left"
                  >
                    <span class="font-[500]"
                      >Do you have warranty? ({{ warranty ? 'Yes' : 'No'
                      }})</span
                    >
                    <div class="flex flex-wrap m-0 text-left items-center">
                      <div
                        class="flex-grow flex-shrink basis-[100%] pt-2 text-left"
                      >
                        <input
                          value="Yes"
                          type="radio"
                          id="warrantyYes"
                          [checked]="warranty === true"
                          (click)="warranty = true"
                          class="mr-[3.5px]"
                        />
                        <label for="warrantyYes">Yes</label>
                        <input
                          value="No"
                          type="radio"
                          id="warrantyNo"
                          [checked]="warranty === false"
                          (click)="warranty = false"
                          class="mr-[3px] ml-[1.4rem]"
                        />
                        <label for="warrantyNo">No</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container relative pb-[1.6rem]">
                <div class="flex flex-wrap items-center">
                  <div
                    class="w-full flex-shrink flex-grow basis-[100%] md:basis-[50%] text-left pb-[1.6rem] md:pb-0"
                  >
                    <span class="font-[500]"
                      >Does it have Full Self-Driving? ({{ fsd ? 'Yes' : 'No'
                      }})</span
                    >
                    <div class="flex flex-wrap m-0 text-left items-center">
                      <div
                        class="flex-grow flex-shrink basis-[100%] pt-2 text-left"
                      >
                        <input
                          value="Yes"
                          type="radio"
                          id="fsdYes"
                          [checked]="fsd === true"
                          (click)="fsd = true"
                          class="mr-[3.5px]"
                        />
                        <label for="fsdYes">Yes</label>
                        <input
                          value="No"
                          type="radio"
                          id="fsdNo"
                          [checked]="fsd === false"
                          (click)="fsd = false"
                          class="mr-[3px] ml-[1.4rem]"
                        />
                        <label for="fsdNo">No</label>
                      </div>
                    </div>
                  </div>
                  <div
                    class="w-full flex-shrink flex-grow basis-[100%] md:basis-[50%] text-left"
                  >
                    <span class="font-[500]"
                      >Do you have the title of the vehicle? ({{ title ? 'Yes' :
                      'No' }})</span
                    >
                    <div class="flex flex-wrap m-0 text-left items-center">
                      <div
                        class="flex-grow flex-shrink basis-[100%] pt-2 text-left"
                      >
                        <input
                          value="Yes"
                          type="radio"
                          id="titleYes"
                          [checked]="title === true"
                          (click)="title = true"
                          class="mr-[3.5px]"
                        />
                        <label for="titleYes">Yes</label>
                        <input
                          value="No"
                          type="radio"
                          id="titleNo"
                          [checked]="title === false"
                          (click)="title = false"
                          class="mr-[3px] ml-[1.4rem]"
                        />
                        <label for="titleNo">No</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container relative">
                <div class="flex flex-wrap items-center">
                  <div class="flex-grow flex-shrink basis-[100%]">
                    <span class="font-[500]"
                      >Have you made any modifications? ({{ modifications ?
                      'Yes' : 'No' }})</span
                    >
                    <div class="flex flex-wrap m-0 text-left items-center">
                      <div
                        class="flex-grow flex-shrink basis-[100%] pt-2 text-left"
                      >
                        <input
                          value="Yes"
                          type="radio"
                          id="modificationsYes"
                          [checked]="modifications === true"
                          (click)="modifications = true"
                          class="mr-[3.5px]"
                        />
                        <label for="modificationsYes">Yes</label>
                        <input
                          value="No"
                          type="radio"
                          id="modificationsNo"
                          [checked]="modifications === false"
                          (click)="modifications = false"
                          class="mr-[3px] ml-[1.4rem]"
                        />
                        <label for="modificationsNo">No</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="w-full mt-16 flex justify-start items-start flex-col text-center"
          >
            <section class="">
              <span>
                By continuing to list your Tesla, you are agreeing to our
                <button
                  (click)="setShowTerms()"
                  tabindex="0"
                  role="button"
                  aria-current="page"
                  class="text-[#3186d0] underline cursor-pointer"
                >
                  Terms of service (click to {{ showTerms ? 'hide' : 'show' }})
                </button>
              </span>
            </section>
            <div
              *ngIf="showTerms"
              class="w-fill h-[200px] overflow-y-auto border text-start mt-5 p-3"
            >
              <out-terms></out-terms>
            </div>
          </div>
          <div class="grid sm:grid-cols-2 gap-5 mt-10">
            <out-button
              label="Save Draft Listing"
              [disabled]="isSavingToContinue || isDraftSaving"
              [isLoading]="isDraftSaving"
              loadingLabel="Saving"
              (click)="draftErrorCheck()"
              buttonClass="!w-full px-3 rounded-lg border-2 !border-[#1466C9] text-[#1466C9] w-full cursor-pointer duration-200 transition-all active:scale-95 font-semibold py-4"
            >
            </out-button>
            <out-button
              [disabled]="isSavingToContinue || isDraftSaving"
              label="Save And Continue"
              loadingLabel="Saving"
              (clicked)="saveListingAndContinue()"
              [isLoading]="isSavingToContinue"
              buttonClass="px-3 rounded-lg border-2 bg-[#1466C9] text-white !w-full cursor-pointer duration-200 transition-all active:scale-95 font-semibold py-4"
            >
            </out-button>
          </div>
        </div>
      </section>
    </form>
  </div>
</div>

<section
  class="bg-black/90 fixed flex items-center justify-center w-screen h-screen left-0 bottom-0 z-[5000]"
  *ngIf="isSaveModalOpen"
>
  <div class="bg-white w-[80%] lg:w-[40%] rounded-lg p-6 space-y-10">
    <div class="space-y-5">
      <div class="w-full flex justify-between border-b border-gray-300 pb-3">
        <h3 class="text-[20px] font-medium">
          Not Live Yet. You are Exiting an Incomplete ad
        </h3>
        <button
          class="hover:bg-gray-400/80 rounded-lg cursor-pointer"
          (click)="toggleSaveModal()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              fill="#3a3a3a"
              d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"
            />
          </svg>
        </button>
      </div>
      <p class="mt-5">
        Your Listing is Incomplete and not submitted to be published live. You
        may return to complete this ad later. Ad is saved as a draft, checkout
        is still pending.
      </p>
    </div>

    <div class="grid lg:grid-cols-2 gap-4 mt-5 justify-normal w-full">
      <out-button
        label="Return to this listing"
        (click)="toggleSaveModal()"
        buttonClass="!w-full py-3 shadow-md !border-[#1466C9] active:scale-95 rounded-lg cursor-pointer transition-colors duration-[400ms]"
      >
      </out-button>

      <out-button
        label="Ok save this listing for later"
        [isLoading]="isDraftSaving"
        loadingLabel="Saving"
        (click)="draftSave()"
        buttonClass="!w-full py-3 text-white rounded-lg cursor-pointer bg-[#1466C9] transition-colors duration-[400ms]"
      >
      </out-button>
    </div>
  </div>
</section>
<out-alert></out-alert>
